import React, { useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import OrigenDestino from "../origenDestino/OrigenDestino";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { enums } from "../../enums/enums";
import DatosMercancia from "../datosMercancia/datosMercancia";
import DatosCliente from "../datosPersonales/DatosCliente";
import SeccionServicioAdicional from "../servicioAdicional/SeccionServicioAdicional";
import Resumen from "../resumen/Resumen";
import Markup from "../markup/Markup";
import Box from "@material-ui/core/Box";
import RegistroUsuario from "../datosPersonales/RegistroUsuario";
import TipoEnvioLista from "../solicitud/TipoEnvioLista";
import ResumenCotizacion from "../resumen/ResumenCotizacion";
import { ICliente } from "../../entities/catalogos/ICliente";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import Header from '../header/Header';
import Proyecto from '../Proyecto/Proyecto';
import ResumenConfirmacion from '../resumen/ResumenConfirmacion';
import { IHelp } from '../help/Help';
import { setUsuario } from '../../redux/actions/usuarioActions';
import { useHistory } from "react-router-dom";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import LoadingDialog from '../controls/LoadingDialog';


interface StateProps {
    solicitud: Solicitud
    cliente: ICliente
    usuario: IUsuario
    recoleccionOrigen: IRecoleccion
    cotizacionID: number
    ayuda: IHelp
}

interface DispatchProps {
    setUsuario: typeof setUsuario
    setSolicitud: typeof setSolicitud
}

type Props = StateProps & DispatchProps

const BodyCotizacion = ({ solicitud, cliente, usuario, setSolicitud, setUsuario }: Props) => {
    const [cotizacionId, setCotizacionID] = useState(0);
    const [cotizacionDTO, setCotizacionDTO] = useState({  });
    const getCotizacionId = (cotizacionId: number) => {
        if (cotizacionId > 0) {
            setCotizacionID(cotizacionId);
        }
    }
    const history = useHistory();
    const [showLoading, setLoading] = useState(false);

    React.useEffect(() => {
        if (cliente?.clienteCredito?.esSuspendido === true && cliente?.clienteCredito?.tipoPagoID === enums.tipoPago.credito) {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(50), //"EL CLIENTE TIENE SU CRÉDITO SUSPENDIDO, NO ES POSIBLE GENERAR COTIZACIÓN.",
                type: 'warning',
            });
            history.push("/");
            return;
        }

    })

    React.useEffect(() => {
        localStorage.setItem("renderiza", "");
    }, [localStorage.getItem("clienteString")]);

    const handleSiguienteSeccion = (siguienteSeccionId: number, datosSeccion: any, cotizacion_ID: any, proyecto?: any, usuario?: IUsuario) => {
        if (siguienteSeccionId === enums.estatusCotizacion.markup && !cliente.habilitarClienteLogistico && !cliente.clienteConfiguracionMarkupDetalle.activo) {
            siguienteSeccionId = enums.estatusCotizacion.datosCliente;
        }

        if (siguienteSeccionId === enums.estatusCotizacion.markup && localStorage["tipo_usuario"].toLowerCase() === "invitado")
            siguienteSeccionId = enums.estatusCotizacion.datosCliente;

        const estatusId = siguienteSeccionId;

        const copiaSolicitud = new Solicitud(solicitud);
        copiaSolicitud.estatusId = estatusId;
        copiaSolicitud.seccionId = siguienteSeccionId;
        copiaSolicitud.tipoDocumento = 1;

        switch (siguienteSeccionId) {
            case enums.estatusSolicitud.proyecto:
                if (cliente.grupoClienteID >= 0 && (cliente.clienteCreditoProyecto && cliente.clienteCreditoProyecto?.length >= 2)) {
                    copiaSolicitud.seccionId = 2;
                }
                copiaSolicitud.completadaMarkup = false;
                break;

            case enums.estatusSolicitud.origenDestino:
                copiaSolicitud.proyecto = proyecto;
                copiaSolicitud.completadaMarkup = false;
                if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
                    copiaSolicitud.correo = datosSeccion.correo;
                    copiaSolicitud.empresaTarifaAlmex = datosSeccion.empresa;
                    copiaSolicitud.nombreTarifaAlmex = datosSeccion.nombre + " " + datosSeccion.apellido;
                    copiaSolicitud.telefonoTarifaAlmex = datosSeccion.telefono;
                    copiaSolicitud.esParticularTarifaAlmex = datosSeccion.esParticular;    
                    copiaSolicitud.nombreInv = datosSeccion.nombre;
                    copiaSolicitud.apellidoInv = datosSeccion.apellido;
                }
                break;
            case enums.estatusCotizacion.datosMercancia:        
                copiaSolicitud.SetComercioExterior(cotizacion_ID);
                copiaSolicitud.SetCruceFronterizo(proyecto);
                if(datosSeccion.claseId !== -1){
                    copiaSolicitud.SetDestino(datosSeccion);
                    if (copiaSolicitud.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.residencial) {
                        copiaSolicitud.esResidencialOrigen = true;
                    }
                    if (copiaSolicitud.tipoRecoleccionIdDestino === enums.tipoRecoleccion.residencial) {
                        copiaSolicitud.esResidencialDestino = true;
                    }
                }
                copiaSolicitud.completadaMarkup = false;
                break;
            case enums.estatusCotizacion.serviciosAdicionales:
                copiaSolicitud.claseId = datosSeccion.claseId;
                copiaSolicitud.clase = datosSeccion.clase;
                copiaSolicitud.completadaMarkup = false;
                copiaSolicitud.CopiarSeccionMercancia(datosSeccion);
                break;
            case enums.estatusCotizacion.markup:
                if (datosSeccion.completada) {
                    copiaSolicitud.id = datosSeccion.solicitudId;
                    copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                    copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                    copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                    copiaSolicitud.tipoMarkupId = datosSeccion.tipoMarkupId;
                    copiaSolicitud.costoMarkup = datosSeccion.costoMarkup;
                    copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;
                    copiaSolicitud.descuento = datosSeccion.descuento;
                    copiaSolicitud.subtotal = datosSeccion.subtotal;
                    copiaSolicitud.retencion = datosSeccion.retencion;
                    copiaSolicitud.iva = datosSeccion.iva;
                    copiaSolicitud.total = datosSeccion.total;
                    copiaSolicitud.totalPesoVolumen = datosSeccion.totalPesoVolumen;
                    copiaSolicitud.esEad = datosSeccion.esEad;
                    copiaSolicitud.esRad = datosSeccion.esRad;
                    copiaSolicitud.montoPesoFacturado = datosSeccion.montoPesoFacturado;
                    copiaSolicitud.totalPesoFacturado = datosSeccion.totalPesoFacturado;
                    copiaSolicitud.totalPesoMercancia = datosSeccion.totalPesoMercancia;
                    copiaSolicitud.unidadMedidaLongitudId = datosSeccion.unidadMedidaLongitudId;
                    copiaSolicitud.unidadMedidaPesoId = datosSeccion.unidadMedidaPesoId;
                    copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                    copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                    copiaSolicitud.completada = true;
                    copiaSolicitud.proyecto = datosSeccion.proyecto;
                    copiaSolicitud.valorMercancia = datosSeccion.valorMercancia;
                    copiaSolicitud.modificar = datosSeccion.modificar ? datosSeccion.modificar : false;
                    copiaSolicitud?.fechaCitaRad?.setMinutes(copiaSolicitud?.fechaCitaRad?.getMinutes() + copiaSolicitud?.fechaCitaRad?.getTimezoneOffset())
                    copiaSolicitud?.fechaCitaEad?.setMinutes(copiaSolicitud?.fechaCitaEad?.getMinutes() + copiaSolicitud?.fechaCitaEad?.getTimezoneOffset())
                    copiaSolicitud.completadaMarkup = true;
                    setCotizacionDTO(cotizacion_ID);
                    setSolicitud(datosSeccion);
                }
                break;
            case enums.estatusCotizacion.datosCliente:
                copiaSolicitud.completadaMarkup = false;
                if (cliente.habilitarClienteLogistico && cliente.clienteConfiguracionMarkupDetalle.activo) {
                    copiaSolicitud.AgruparServicios(datosSeccion);
                    copiaSolicitud.CopiarMarkup(datosSeccion);
                } else {
                    copiaSolicitud.AgruparServicios(datosSeccion);
                }
                break;
            //case enums.estatusCotizacion.markup:
            case enums.estatusCotizacion.tipoEnvio:
            case enums.estatusCotizacion.cotizacion:
                copiaSolicitud.solicitudId = cotizacion_ID;
                if(localStorage["tipo_usuario"].toLowerCase() !== "invitado"){
                    copiaSolicitud.correo = datosSeccion.correo;
                    copiaSolicitud.empresaTarifaAlmex = datosSeccion.empresa;
                    copiaSolicitud.nombreTarifaAlmex = datosSeccion.nombre;
                    copiaSolicitud.telefonoTarifaAlmex = datosSeccion.telefono;
                    copiaSolicitud.esParticularTarifaAlmex = datosSeccion.tipoPersonaId === 2 ? 0 : 1;
                }

                if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
                    if(!datosSeccion.completada){
                        if (cliente.habilitarClienteLogistico && cliente.clienteConfiguracionMarkupDetalle.setTabActivo) {
                            copiaSolicitud.AgruparServicios(datosSeccion);
                            copiaSolicitud.CopiarMarkup(datosSeccion);
                        } else {
                            copiaSolicitud.AgruparServicios(datosSeccion);
                        }
                    }
                }

                if (datosSeccion.completada) {
                    copiaSolicitud.id = datosSeccion.id;
                    copiaSolicitud.serviciosAdicionales = datosSeccion.serviciosAdicionales;
                    copiaSolicitud.markupMonto = datosSeccion.markupMonto;
                    copiaSolicitud.markupPorcentaje = datosSeccion.markupPorcentaje;
                    copiaSolicitud.tipoMarkupId = datosSeccion.tipoMarkupId;
                    copiaSolicitud.costoMarkup = datosSeccion.costoMarkup;
                    copiaSolicitud.costoSeguro = datosSeccion.costoSeguro;
                    copiaSolicitud.descuento = datosSeccion.descuento;
                    copiaSolicitud.subtotal = datosSeccion.subtotal;
                    copiaSolicitud.retencion = datosSeccion.retencion;
                    copiaSolicitud.iva = datosSeccion.iva;
                    copiaSolicitud.total = datosSeccion.total;
                    copiaSolicitud.totalPesoVolumen = datosSeccion.totalPesoVolumen;
                    copiaSolicitud.esEad = datosSeccion.esEad;
                    copiaSolicitud.esRad = datosSeccion.esRad;
                    copiaSolicitud.montoPesoFacturado = datosSeccion.montoPesoFacturado;
                    copiaSolicitud.totalPesoFacturado = datosSeccion.totalPesoFacturado;
                    copiaSolicitud.totalPesoMercancia = datosSeccion.totalPesoMercancia;
                    copiaSolicitud.unidadMedidaLongitudId = datosSeccion.unidadMedidaLongitudId;
                    copiaSolicitud.unidadMedidaPesoId = datosSeccion.unidadMedidaPesoId;
                    copiaSolicitud.tipoEnvio = datosSeccion.tipoEnvio;
                    copiaSolicitud.tipoServicio = datosSeccion.tipoServicio;
                    copiaSolicitud.completada = true;
                    copiaSolicitud.proyecto = datosSeccion.proyecto;
                    copiaSolicitud.valorMercancia = datosSeccion.valorMercancia;
                    copiaSolicitud.modificar = datosSeccion.modificar ? datosSeccion.modificar : false;
                    copiaSolicitud.completadaMarkup = false;
                    setSolicitud(datosSeccion);

                    if (usuario) {
                        localStorage.setItem('usuario_nombre', usuario.nombre);
                        localStorage.setItem('tipo_usuario', 'User');
                        setUsuario({ ...usuario, id: 1, esInvitado: false });
                        history.push("/");
                    }
                }
                break;
            case enums.estatusCotizacion.resumen:
                copiaSolicitud.completada = true;
                copiaSolicitud.modificar = false;
                copiaSolicitud.subtotal = datosSeccion.subtotal;
                copiaSolicitud.iva = datosSeccion.iva;
                copiaSolicitud.retencion = datosSeccion.retencion;
                copiaSolicitud.total = datosSeccion.total;
                setSolicitudCopia(datosSeccion);
                break;
            default:
                break;
        }

        setSolicitud(copiaSolicitud);
    };



    setSolicitud(solicitud);
    let seccion;
    const actualizarIdioma = (idiomaId: string) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
          }, 1000);
        
    }

    switch (solicitud.seccionId) {
        // switch (2) {
        
        case enums.estatusCotizacion.datosClienteInv:
            seccion = <DatosCliente siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.proyecto:

            if (
                (cliente.clienteCreditoProyecto && cliente.clienteCreditoProyecto?.length === 1 &&
                    cliente.clienteCreditoProyecto[0].clienteCreditoProyectoID === 0)) {
                seccion = <OrigenDestino siguienteSeccion={handleSiguienteSeccion} setCotizacionID={getCotizacionId} cotizacionId={cotizacionId} />;
            }
            else {
                seccion = <Proyecto cotizacionId={cotizacionId} siguienteSeccion={handleSiguienteSeccion} tipo={'cotizacion'} changeIdioma={actualizarIdioma}/>;
            }

            break;
        case enums.estatusCotizacion.origenDestino:
            seccion = <OrigenDestino siguienteSeccion={handleSiguienteSeccion} setCotizacionID={getCotizacionId} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.datosMercancia:
             seccion = <DatosMercancia siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.serviciosAdicionales:
            seccion = <SeccionServicioAdicional siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.markup:
            //seccion = <Markup siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} solicitudDTO={cotizacionDTO} changeIdioma={actualizarIdioma}/>;
            seccion = <TipoEnvioLista siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} solicitudDTO={cotizacionDTO} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.datosCliente:
            seccion = <DatosCliente siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.tipoEnvio:
            seccion = <TipoEnvioLista siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.cotizacion:
            seccion = <ResumenCotizacion siguienteSeccion={handleSiguienteSeccion} cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>
            break;
        case enums.estatusCotizacion.resumen:
            seccion = <ResumenConfirmacion cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        case enums.estatusCotizacion.registroUsuario:
            seccion = <RegistroUsuario cotizacionId={cotizacionId} changeIdioma={actualizarIdioma}/>;
            break;
        default:
            break;
    }



    return (<>
        <Header name="Developer" tipo={!solicitud.tipoSolicitud ? 'cotizacion' : solicitud.tipoSolicitud} solicitud={solicitud} changeIdioma={actualizarIdioma}/>
        <div style={{ width: '90%', margin: 'auto', flexGrow: 1, marginTop: '2em', minHeight: "400px" }}>

            {cliente?.id !== null && !solicitud.completada &&
                <Grid container spacing={4}>
                    <Box clone order={{ xs: 2, md: 1 }}>
                        <Grid item xs={12} md={8}>
                            <Paper elevation={3}>
                                {seccion}
                            </Paper>
                        </Grid>
                    </Box>
                    <Box clone order={{ xs: 1, md: 2 }}>
                        <Grid item xs={12} md={4}>
                            <Resumen changeIdioma={actualizarIdioma}/>
                        </Grid>
                    </Box>

                </Grid>


            }

            {solicitud.completada && solicitud.modificar && solicitud.seccionId !== 8 && solicitud.seccionId !== 9 &&
                <Grid container spacing={4}>
                    <Box clone order={{ xs: 2, md: 1 }}>
                        <Grid item xs={12} md={8}>
                            <Paper elevation={3}>
                                {seccion}
                            </Paper>
                        </Grid>
                    </Box>
                    <Box clone order={{ xs: 1, md: 2 }}>
                        <Grid item xs={12} md={4}>
                            <Resumen changeIdioma={actualizarIdioma}/>
                        </Grid>
                    </Box>

                </Grid>


            }

            {solicitud.completada && (solicitud.seccionId === 8 || solicitud.seccionId === 9) &&
                <>{seccion}</>
            }
            {
            showLoading &&
            //Procesando
                <> <LoadingDialog titulo={'Procesando'} abierto={true} /></>
            }


        </div>
    </>)
};

const mapStateToProps = (state: ApplicationState) => (
    {
        solicitud: state.solicitud,
        cliente: state.cliente,
        recoleccionOrigen: state.recoleccionDestino,
        recoleccionDestino: state.recoleccionDestino,
        usuario: state.usuario,
        ayuda: state.ayuda,
        idiomaId: state.idioma
    });

const mapDispatchToProps = {
    setUsuario: setUsuario,
    setSolicitud: setSolicitud
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyCotizacion);
